/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The type of a EVM token.
 * @export
 * @enum {string}
 */
export enum EvmTokenType {
    Erc20 = 'ERC20',
    Erc721 = 'ERC721'
}

export function EvmTokenTypeFromJSON(json: any): EvmTokenType {
    return EvmTokenTypeFromJSONTyped(json, false);
}

export function EvmTokenTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvmTokenType {
    return json as EvmTokenType;
}

export function EvmTokenTypeToJSON(value?: EvmTokenType | null): any {
    return value as any;
}

